import { useCallback, useEffect, useState } from "react";
import { BUSINESS_AREA_SETTINGS_API_URL } from "../config/constants";
import { apiFetch } from "../utils/apiClient";



export const useBusinessDomains = () => {
  const [businessDomainOptions, setBusinessDomainOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadBusinessDomains = useCallback(async () => {
    setLoading(true);

    try {
      const token =
        sessionStorage.getItem("token") ||
        sessionStorage.getItem("authToken") ||
        sessionStorage.getItem("accessToken");

      const tokenType = sessionStorage.getItem("tokenType") || "Bearer";

      const res = await apiFetch(BUSINESS_AREA_SETTINGS_API_URL, {
        method: "GET",
        headers: {
          Authorization: `${tokenType} ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }, "Failed to load business domains");

      if (!res.ok) {
        throw new Error("Failed to load business domains");
      }

      const data = await res.json();

      setBusinessDomainOptions(
        Array.isArray(data)
          ? data.map((item) => ({
              value: item.domainName,
              label: item.domainName,
            }))
          : [],
      );
    } catch (error) {
      console.error("Failed to load business domains", error);
      setBusinessDomainOptions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void loadBusinessDomains();
  }, [loadBusinessDomains]);

  return {
    businessDomainOptions,
    loading,
    reloadBusinessDomains: loadBusinessDomains,
  };
};